const Overview = () => {
    return (
        <div id="overview" className="vision-card overview-card">

            {/* PAGE INTRO */}

            <div className="overview-header">

                <h2>
                    OVERVIEW
                </h2>

                <div className="overview-title-line"></div>

            </div>


            {/* SCHOOL NAME */}

            <div className="overview-school-name">
                Nav Jeevan Mission School, Anandnagar
            </div>


            {/* OVERVIEW CONTENT */}

            <div className="overview-content">

                <p>
                    Nav Jeevan Mission School, Anandnagar is a co-educational
                    school committed to providing quality education and
                    nurturing students into confident, responsible and
                    compassionate individuals. The school provides education
                    from Nursery to Class XII and strives to create a safe,
                    disciplined and inspiring environment where every child is
                    encouraged to learn, explore and excel.
                </p>

                <p>
                    Our educational approach focuses on the holistic development
                    of students, giving importance not only to academic
                    excellence but also to character formation, values,
                    discipline, creativity, leadership, sports and
                    co-curricular activities.
                </p>

                <p>
                    The school provides opportunities for students to develop
                    critical thinking, communication skills, digital literacy
                    and problem-solving abilities through modern teaching
                    practices and technology-enabled learning.
                </p>


                {/* KEY STRENGTHS */}

                <div className="overview-section">

                    <div className="overview-section-heading">
                        <span className="overview-section-dot"></span>

                        <h3>
                            Our Key Strengths
                        </h3>
                    </div>


                    <ul className="overview-strengths">

                        <li>
                            Quality and value-based education
                        </li>

                        <li>
                            Experienced and dedicated teaching faculty
                        </li>

                        <li>
                            Smart classrooms and technology-enabled learning
                        </li>

                        <li>
                            Computer and Artificial Intelligence learning facilities
                        </li>

                        <li>
                            Sports and co-curricular activities
                        </li>

                        <li>
                            Arts, cultural and literary programmes
                        </li>

                        <li>
                            Olympiads and competitive examinations
                        </li>

                        <li>
                            Leadership and personality development
                        </li>

                        <li>
                            Strong school–parent partnership
                        </li>

                        <li>
                            Safe, disciplined and child-friendly learning environment
                        </li>

                    </ul>

                </div>


                {/* SCHOOL APPROACH */}

                <p>
                    At Nav Jeevan Mission School, we believe that every child
                    is unique and capable of excellence. Our dedicated team
                    works closely with parents to identify each student’s
                    potential, provide appropriate guidance and encourage them
                    to achieve their goals.
                </p>


                {/* VISION */}

                <div className="overview-highlight overview-vision">

                    <span>
                        OUR VISION
                    </span>

                    <h3>
                        Our Vision
                    </h3>

                    <p>
                        To educate, empower and inspire young minds to become
                        knowledgeable, disciplined, confident and compassionate
                        individuals who contribute positively to society and
                        the nation.
                    </p>

                </div>


                {/* MOTTO */}

                <div className="overview-highlight overview-motto">

                    <span>
                        OUR MOTTO
                    </span>

                    <h3>
                        “Learn • Grow • Excel”
                    </h3>

                    <p>
                        Nav Jeevan Mission School, Anandnagar — Nurturing Minds,
                        Building Character, Inspiring Excellence.
                    </p>

                </div>

            </div>

        </div>
    );
};

export default Overview;